<div class="home-block" id="coming-soon">
  <img
    alt=""
    height="681"
    id="coming-soon-img"
    loading="lazy"
    src="multimedia/home/coming-soon.webp"
    width="1223"
  />
  <div class="home-container">
    <div id="coming-soon-container">
      <hr />
      <div class="progress-bar">
        <div class="progress">COMING SOON</div>
      </div>
      <table>
        <tr>
          <th>{{ days }}</th>
          <th>:</th>
          <th>{{ hours }}</th>
          <th>:</th>
          <th>{{ minutes }}</th>
          <th>:</th>
          <th>{{ seconds }}</th>
        </tr>
        <tr>
          <td>nap</td>
          <td></td>
          <td>óra</td>
          <td></td>
          <td>perc</td>
          <td></td>
          <td>mp</td>
        </tr>
      </table>
    </div>
  </div>
</div>
